module.exports = __webpack_public_path__ + "img/ff1.1b7c676b.png";